import { useTranslations } from 'next-intl';

import { cn } from '@/utils/cn';

interface ActionRequiredBadgeProps {
  isRoot?: boolean;
}

/** Toolbar badge: user action required (replaces unread count while signing is needed). */
const ActionRequiredBadge: React.FC<ActionRequiredBadgeProps> = ({ isRoot = false }) => {
  const t = useTranslations('notifications');
  return (
    <div
      role="status"
      className={cn(
        'flex items-center justify-center w-3 h-3 lg:w-4 lg:h-4 rounded-full bg-yellow-warning',
        isRoot && 'absolute top-[2px] right-[4px] lg:top-[5px] lg:right-[5px]',
        !isRoot && 'w-4 h-4',
      )}
      title={t('actionRequired')}
    >
      <span className={cn('leading-none text-[8px] lg:text-[11px] font-bold text-gray-900', !isRoot && 'text-[11px]')}>!</span>
    </div>
  );
};

export default ActionRequiredBadge;
